 <template>
  <!-- Margen de tarjeta -->
  <div class="tarjeta-prospecto shadow mb-3 bg-white">
    <!-- Contenedor de tarjeta -->
    <div class="row">
      <!-- Titular -->
      <div class="col-4 contenedor-nombre" style="border-right: 2px solid #b8725a;">
        <div class="prospecto_datos w-100">
            <small v-if="tipoPersona == 0 || tipoPersona == 1 || tipoPersona == 3 || tipoPersona == 4 || tipoPersona == 6"
            v-on:click="RedirigirPantalla(prospectoId, tipoPersona)"
            class="nombre-prospecto"
          >
            {{
              tipoPersona == 0
                ? "TITULAR N: "
                : tipoPersona == 1
                ? "TITULAR M: "
                : tipoPersona == 3
                ? "REPRESENTANTE L: "
                : tipoPersona == 4
                ? "COTITULAR: "
                : tipoPersona == 6
                ? "OBLIGADO SOLIDARIO: "
                : ""
            }}
            {{ nombreProspecto }} {{ apellidoPaterno }} {{ apellidoMaterno }}
          </small>
          <small v-else-if="tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7"
            v-on:click="RedirigirPantalla(prospectoId, tipoPersona)"
            class="nombre-prospecto"
          >
            {{
              tipoPersona == 2
                ? "TITULAR E:"
                : tipoPersona == 5
                ? "CO-OWNER: "
                : tipoPersona == 7
                ? "JOINT LIABILITY: "
                : ""
            }}
            {{ nombreProspecto }} {{ apellidoMaterno }} {{ apellidoPaterno }} 
          </small>
          <!--Iconos Editar-->
          <span
            style="margin-left: 5px; margin-right: 5px;"
            v-if="
              (tipoUsuario == embajadores ||
                tipoUsuario == gerente ||
                tipoUsuario == masterOperativo ||
                tipoUsuario == administradorComercial ||
                tipoUsuario == gerenteRegional) &&
                (etapa == 'PRIMER CONTACTO' || etapa == 'ASESORÍA')
            "
          >
            <i
              class="far fa-edit"
              style="color: #b8725a; cursor: pointer; margin-left:2px; margin-right:2px;"
              v-on:click="EditarProspecto(prospectoId)"
            ></i>
          </span>
          <span
            style="margin-left: 5px; margin-right: 5px;"
            v-tooltip.right="'Ver el expediente del prospecto.'"
            v-if="
              tipoUsuario != prospecto &&
                tipoUsuario != administrador &&
                tipoUsuario != masterComercial &&
                etapaId > 3 &&
                etapaId < 10
            "
          >
            <!--Iconos Expediente-->
            <i
              @click="VerExpedienteDelProspecto(prospectoId, tipoPersona)"
              data-bs-toggle="modal"
              data-bs-target="#modalEstatus"
              class="fas fa-folder"
              style="color: #b8725a; cursor: pointer; margin-left:2px; margin-right:2px;"
            ></i>
          </span>

          <span style="margin-left: 5px; margin-right: 5px;"
            v-if="
              tipoUsuario != 1 &&
                tipoUsuario != 3 &&
                tipoUsuario != 7 &&
                etapaId > 3 &&
                etapaId < 5
            "
          >
          <!--Iconos Eliminar-->
          <i
            class="fa fa-ban"
            style="color: #b8725a; cursor: pointer; margin-left:2px; margin-right:2px;"
            v-on:click="EliminarProspecto(prospectoId, true)"
          ></i>
          </span>

          <span style="margin-left: 5px; margin-right: 5px;"
            v-if="
            AplicaAdicionales &&            
            (tipoUsuario == 1 ||
              tipoUsuario == 4 ||
              tipoUsuario == 5 ||
              tipoUsuario == 6 ||
              tipoUsuario == 7 ||
              tipoUsuario == 8 ||
              tipoUsuario == 9 ||
              tipoUsuario == 10) &&
              (tipoPersona == 0 || tipoPersona == 2)
          ">
            <i
          class="fas fa-ellipsis-v"          
          v-on:mouseover="MostrarAdicionales()"
        ></i>
            </span>
        </div>
        <div class="col-lg-8" v-if="MuestraAgregaAdicionales && etapaId <= 5                  
                ">
          <ul class="embajadores-dropdown">
            <li
              class="embajadores-element"
              style="margin-top:5px; margin-bottom:5px;"
              v-for="figura in figuras"
              :key="figura.prospectoId"
            >
              <i v-if="(figura.nombreCompleto == 'COTITULAR' ||
                  figura.nombreCompleto == 'OBLIGADO SOLIDARIO' ||
                  figura.nombreCompleto == 'CO-OWNER' ||
                  figura.nombreCompleto == 'JOINT LIABILITY')"
                class="fas fa-user-plus"
                style="color: #b8725a; cursor: pointer;"
              ></i>
              <i class="espacio"></i>
              <a  v-if="(figura.nombreCompleto == 'COTITULAR' ||
                  figura.nombreCompleto == 'OBLIGADO SOLIDARIO' ||
                  figura.nombreCompleto == 'CO-OWNER' ||
                  figura.nombreCompleto == 'JOINT LIABILITY')"
                style="text-decoration: underline;"
                @click="AgregarFiguraAdicional(figura)"
                >{{ figura.nombreCompleto }}</a
              >  
            </li>
          </ul>
        </div>
        <!-- Figuras Adicionales -->
        <div v-if="AplicaAdicionales && TieneAdicionales" class="informacion-tarjeta-margen">
          <div
            class="embajadores-element"
            v-for="figura in figuras"
            :key="figura.prospectoId"
          >
            <!--Perfiles Administrativos-->
            
            <p
              v-if="
              (figura.prospectoId > 0)
              "
              v-on:click="RedirigirPantalla(figura.prospectoId, figura.tipoFigura)"
              class="informacion-tarjeta-margen informacion-tarjeta-font w-100 p-3"
            >
             {{
                figura.tipoFigura == 4
                ? "COTITULAR: "
                : figura.tipoFigura == 5
                ? "CO-OWNER: "
                : figura.tipoFigura == 6
                ? "OBLIGADO SOLIDARIO: "
                : figura.tipoFigura == 7
                ? "JOINT LIABILITY: "
                : ""
            }}
              {{ figura.nombreCompleto }}
         
            <!--Iconos Editar-->
            <span style="margin-left: 5px; margin-right: 5px;"
              v-if="
                (tipoUsuario == 1 || tipoUsuario == 6 || tipoUsuario == 8 || tipoUsuario == 9 || tipoUsuario == 10) &&
                  (etapa == 'PRIMER CONTACTO' || etapa == 'ASESORÍA') &&  (figura.prospectoId > 0)
              "
            >
            <i
              class="far fa-edit icono-tarjeta"
              style="color: #b8725a; cursor: pointer"
              v-on:click="EditarProspecto(figura.prospectoId)"
            ></i>
            </span>
          
            <span 
              style="margin-left: 5px; margin-right: 5px;"
              v-tooltip.right="'Ver el expediente del prospecto.'"
              v-if="
                tipoUsuario != 3 &&
                  tipoUsuario != 5 &&
                  tipoUsuario != 7 &&
                  etapaId > 3 &&
                  etapaId < 10 && 
                  (figura.prospectoId > 0)
              "
            >
              <!--Iconos Expediente-->
              <i
                @click="
                  VerExpedienteDelProspecto(
                    figura.prospectoId,
                    figura.tipoFigura
                  )
                "
                data-bs-toggle="modal"
                data-bs-target="#modalEstatus"
                class="fas fa-folder icono-tarjeta"
                style="color: #b8725a; cursor: pointer"
              ></i>
            </span>
            <span style="margin-left: 5px; margin-right: 5px;"
              v-tooltip.right="'Eliminar prospecto.'"
              v-if="
                tipoUsuario != 1 &&
                  tipoUsuario != 3 &&
                  tipoUsuario != 7 &&
                  etapaId > 3 &&
                  etapaId < 5 &&
                  figura.prospectoId > 0
              "
            >
            <!--Iconos Eliminar-->
            <i
              class="fa fa-ban icono-tarjeta"
              style="color: #b8725a; cursor: pointer"
              v-on:click="EliminarProspecto(figura.prospectoId, true)"
            ></i>
             </span>
            </p>
          </div>
        </div>
      </div>
      <!--Monto-->
      <div class="col-2 contenedor-nombre" style="border-right: 2px solid #b8725a; text-align:center;">
        <div class="informacion-tarjeta">
          <label class="informacion-tarjeta prospecto-monto negritas w-100">Monto:</label>
        </div>
          <div class="informacion-tarjeta">
          <label class="informacion-tarjeta prospecto-monto w-100">
            {{ DarFormatoMoneda(montoDeseado) }}</label
          >
        </div>
      </div>
      <!--Etapa-->
      <div class="col-3 contenedor-nombre" style="border-right: 2px solid #b8725a; text-align:center;">
        <div class="informacion-tarjeta">
          <div class="prospecto-estado__icono">
            <span v-tooltip.right="toolTip">
              <i id="icono-etapa" :class="InsertarIcono(etapa)"></i>
            </span>
          </div>
          <div class="informacion-tarjeta">
            <label class="nombre-etapa">{{ aliasEtapaStr }}</label>
          </div>
        </div>
      </div>       
      <!--Datos Adicionales-->
      <div class="col-3 contenedor-nombre">
        <div class="informacion-tarjeta">
          <div class="informacion-tarjeta w-100">
            <label class="informacion-tarjeta prospecto-monto negritas w-100">Sucursal:</label>
            </div>
            <div class="informacion-tarjeta">
            <label class="informacion-tarjeta prospecto-monto w-100">
              {{ sucursal }}</label
            >
          </div>
          <div class="informacion-tarjeta negritas w-100">
            <label class="informacion-tarjeta prospecto-monto negritas w-100">Embajador:</label>
            </div>
            <div class="informacion-tarjeta">
            <label class="informacion-tarjeta prospecto-monto w-100">
             {{ embajador }}</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

import axios from "axios";
import servicios from "../../../servicios/service.js";
//Variables
var rutaProspectos = "/api/Master/Prospecto/ListarProspectos";
var rutaObtenerPantalla = "/api/Master/Etapa/ConsultarVistaFlujoProspecto";
var rutaObtenerFiguraAdicional = "/api/Master/FiguraAdicional/ListarFiguraAdicional";
var rutaEliminarProspecto = "/api/Master/Prospecto/EliminarProspecto";

export default {
  name: "TarjetaProspecto",
  components: {
  },
  data() {
    return {
      embajadoresInactivo: 0,
      embajadores: 1,
      prospectoInactivo: 2,
      prospecto: 3,
      preautorizador: 4,
      administrador: 5,
      gerente: 6,
      masterComercial: 7,
      masterOperativo: 8,
      gerenteRegional: 9,
      administradorComercial: 10,
      tipoUsuario: null,
      AplicaAdicionales: false,
      MuestraAgregaAdicionales: false,
      TieneAdicionales: false,
      figuras: [],
    }
  },
  props: {
    prospectoId: Number,
    nombreProspecto: String,
    estatusProspecto: String,
    fechaStr: String,
    apellidoPaterno: String,
    apellidoMaterno: String,
    montoDeseado: Number,
    aliasEtapaStr: String,
    tipoPersona: Number,
    toolTip: String,
    etapa: String,
    etapaId: Number,
    estatus: String,
    fechaPreautorizacion: String,
    fechaPago: String,
    sucursal: String,
    embajador: String
  },
  mounted() {
    this.tipoUsuario = this.$store.getters.tipoUsuario;

    this.ListarFigurasAdicionales(this.prospectoId, this.tipoPersona);
    if(this.tipoUsuario == 1 ||
    this.tipoUsuario == 4 ||
    this.tipoUsuario == 5 ||
    this.tipoUsuario == 6 ||
    this.tipoUsuario == 7 ||
    this.tipoUsuario == 8 ||
    this.tipoUsuario == 9 ||
    this.tipoUsuario == 10)
    {
      this.AplicaAdicionales = true;
    }
  },
  methods: {
  AgregarFiguraAdicional(item) {
      if (item != null && item.prospectoId != 0) {
        switch (item.prospectoId) {
          case -1:
            this.CrearFiguraAdicional(this.prospectoId, item.tipoFigura);
            break;
          case -2:
            this.CrearFiguraAdicional(this.prospectoId, item.tipoFigura);
            break;
          default:
            this.VerExpedienteDelProspectoAdicional(item.prospectoId, item.tipoFigura)
            break;
        }
      }
    },
    EliminarProspecto(ProspectoId, esProspecto){
      this.$fire({
        title: esProspecto ? "Eliminar prospecto" : "Eliminar Figura",
        html:
            "<br>Estás por eliminar a un prospecto y/o figura adicional<br>" +
            "¿Estas seguro que deseas continuar?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value) {
        axios.post(rutaEliminarProspecto + "/?prospectoId=" +  ProspectoId)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.$fire({
        title: esProspecto ? "Eliminar prospecto" : "Eliminar Figura",
        html:
            "<br>Prospecto y/o figura adicional eliminada correctamente<br>" +
            "En un momento se recargara la información...<br>",
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
      }),
            this.$router.go(0);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores("Ocurrio un error al eliminar al prospecto y/o figura adicional.",true, false);
            this.$router.go(0);
          }
        })
        .catch(e => {
             this.ManejarExcepcion(e);
             this.$router.go(0);
        });
        }
      });
    },
     cargarProspectos(){
      if(this.tipoUsuario != 4 && this.tipoUsuario != 5 && this.tipoUsuario != 6 && this.tipoUsuario != 8 && this.tipoUsuario != 9 && this.tipoUsuario != 10) {
        const cuerpo = {
          params:{
            NombreOEtapa:"",
            FiltrarPorMaster:true,
          }
        }
        axios
        .get(rutaProspectos,cuerpo)
        .then((response) => {
          if (response.data.estado === 0)
            this.prospectos = response.data.data;
        }).catch((e) => this.ManejarExcepcion(e));
      } else {
        this.cargarPropectosPorRol();
      }
    },
    MostrarAdicionales() {
      if (!this.MuestraAgregaAdicionales) {
        this.MuestraAgregaAdicionales = true;
      }
      else {
        this.MuestraAgregaAdicionales = false;
      }
    },
    ListarFigurasAdicionales(prospectoId, tipoPersona) {
      const parametroProspecto = {
        params: {
          prospectoId: prospectoId,
          tipoPersona: tipoPersona
        }
      }
      axios
        .get(rutaObtenerFiguraAdicional, parametroProspecto)
        .then(resp => {
          if (resp.data.estado === 0) {   
            this.figuras = resp.data.data;
             if(this.figuras.length > 2)
            {
              this.TieneAdicionales = true;
            }        
          }
          else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false, false);
          }
          else {
            this.AlertaEmbajadores(resp.data.mensaje, false, false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    DarFormatoMoneda(monto) {
      return servicios.DarFormatoMoneda(monto);
    },
    InsertarIcono(etapa) {
      switch (etapa) {
        case 'PRIMER CONTACTO':
          return "far fa-calendar-check";
        case 'ASESORÍA':
          return "fas fa-headset";
        case 'INTEGRACIÓN DE EXPEDIENTE':
          return "far fa-file-alt";
        case 'PRE AUTORIZACIÓN':
          return "fas fa-clipboard-check";
        case 'GENERACIÓN INFORMACIÓN DE PAGO':
          return "fas fa-money-check-alt";
        case 'PAGO DE CUOTA DE INSCRIPCIÓN':
          return "fas fa-file-invoice-dollar";
        case 'VALIDAR PAGO':
          return "fas fa-check-circle";
        case 'CONTRATADO':
          return "fas fa-user-check";
        case 'PAUSADO':
          return "far fa-pause-circle";
        case 'COMPLETADO':
          return "fal fa-badge-check";
        case 'HOJA PRUEBA':
          return "far fa-clipboard-list";
        default:
          break;
      }
    },
    RedirigirPantalla(prospectoId, tipoPersona) {
    if(prospectoId <= 0)
    {return;}
      const parametroProspecto = {
        params: {
          prospectoId: prospectoId
        }
      }
      axios
        .get(rutaObtenerPantalla, parametroProspecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data != "") {
              let pantalla = resp.data.data;
              var tipo = this.tipoUsuario;
              //Pre autorizador, administrador y master operativo pueden acceder y solo Pre autorizador y master operativo pueden preautorizar
              if (pantalla == "PreAutorizacion" && (tipo == 1 || tipo == 4 || tipo == 8 || tipo == 10)) {
                this.$store.commit('setProspecto', prospectoId);
                this.$store.commit('setTipoPersona', tipoPersona);
                this.$router.push({
                  name: pantalla
                });
              }
              else if ((tipo == 1 || tipo == 3 || tipo == 5 || tipo == 6 || tipo == 7 || tipo == 9) && pantalla == "PreAutorizacion") {
                this.AlertaEmbajadores(servicios.CrearMensaje(tipo, tipoPersona, pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
              } else if ((tipo == 1 || tipo == 3 || tipo == 6 || tipo == 7 || tipo == 9) && pantalla == "GenerarInformacionDePago") {
                this.AlertaEmbajadores(servicios.CrearMensaje(tipo, tipoPersona, pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
              } else if ((tipo == 1 || tipo == 3 || tipo == 4 || tipo == 6 || tipo == 7 || tipo == 9) && pantalla == "ValidarPago") {
                this.AlertaEmbajadores(servicios.CrearMensaje(tipo, tipoPersona, pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
              } else if ((tipo == 7) && pantalla == "CargarInformacionDePago") {
                this.AlertaEmbajadores(servicios.CrearMensaje(tipo, tipoPersona, pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
              }
              else if ((tipo == 1 || tipo == 4 || tipo == 5 || tipo == 6 || tipo == 8 || tipo == 9 || tipo == 10) && pantalla == "CargarInformacionDePago") {
                this.$store.commit('setProspecto', prospectoId);
                this.$store.commit('setTipoPersona', tipoPersona);
                this.$router.push({ name: pantalla });
              }
              else if ((tipo == 1 || tipo == 4 || tipo == 6 || tipo == 7 || tipo == 9) && pantalla == "CajaDorada") {
                this.AlertaEmbajadores((tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "The prospect is already hired and has access to their Welcome Kit." : "El prospecto ya se encuentra contratado y tiene acceso a su Kit de Bienvenida.", true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
              }
              else if (pantalla == "SeguimientoProspecto") {
                this.$store.commit('setProspecto', prospectoId);
                this.$store.commit('setTipoPersona', tipoPersona);
                switch (tipoPersona) {
                case 0:
                case 4:
                case 6:
                this.$router.push({ name: "IntegracionExpediente"});
                break;
                case 1:
                this.$router.push({ name: "IntegracionExpedienteMoral"});
                break;
                case 2:
                case 5:
                case 7:
                this.$router.push({ name: "IntegracionExpedienteExtranjero"});
                break;
                }
              }
              else if ((tipo == 1 || tipo == 4 || tipo == 6 || tipo == 7 || tipo == 9 ) && pantalla == "HojaPrueba") {
                this.AlertaEmbajadores("El prospecto se encuentra en validación de Hoja de Prueba.", true, false);
              }
              else {
                this.$store.commit('setProspecto', prospectoId);
                this.$store.commit('setTipoPersona', tipoPersona);
                this.$router.push({ name: pantalla });
              }
            } else {
              this.AlertaEmbajadores(resp.data.mensaje,false,false);
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje,false,false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    EditarProspecto(prospectoId) {
      this.$store.commit('setCrearProspecto', false);
      this.$store.commit('setEditarProspecto', true);
      this.$store.commit('setRegistroFiguraAdicional',false);
      window.sessionStorage.setItem('prospectoEditarId', prospectoId);
      this.$router.push("/RegistroProspecto");
    },
    VerExpedienteDelProspecto(prospectoId, tipoPersona) {
      this.$store.commit('setProspecto', prospectoId);
      switch (tipoPersona) {
        case 0:
        case 4:
        case 6:
          this.$router.push({ name: "IntegracionExpediente", params: { vieneDeAdministracion: true } });
          break;
        case 1:
          this.$router.push({ name: "IntegracionExpedienteMoral", params: { vieneDeAdministracion: true } });
          break;
        case 2:
        case 5:
        case 7:
          this.$router.push({ name: "IntegracionExpedienteExtranjero", params: { vieneDeAdministracion: true } });
          break;
      }
    },
    VerExpedienteDelProspectoAdicional(prospectoId, tipoFigura) {
      this.$store.commit('setProspecto', prospectoId);
      this.$store.commit('setTipoPersona', tipoFigura);
      this.$store.commit('setTipoFiguraAdicional', tipoFigura);
      if(tipoFigura == 4 || tipoFigura == 6)
      {
      this.$router.push({ name: "IntegracionExpediente" });
      }
      else if(tipoFigura == 5 || tipoFigura == 7)
      {
      this.$router.push({ name: "IntegracionExpedienteExtranjero" });
      }
    },
    CrearFiguraAdicional(prospectoId, tipoFigura) {
      this.$store.commit('setCrearProspecto', true);
      this.$store.commit('setEditarProspecto', false);
      this.$store.commit('setRegistroFiguraAdicional', true);
      this.$store.commit('setTipoPersona', tipoFigura);
      this.$store.commit('setProspectoPadreFiguraAdicionalId', prospectoId);
      this.$store.commit('setTipoFiguraAdicional', tipoFigura);
      this.$router.push({
        name: "RegistroProspecto"
      });
    }
  },
};
</script>

<style scoped lang="scss">
$color-primario: #b8725a;
$poppins: "Poppins";
$gris-deshabilitado: #bcbcbc;

.espacio {
  margin-left: 10px;
}

.embajadores-element {
  width: 100%;
  margin-left: -20px;
  color: #000000;
}

.embajadores-element :hover {
  background-color: #f3dfd9;
}

.embajadores-dropdown {
  cursor: pointer;
  min-width: 350px;
  max-width: 500px;
  -webkit-appearance: none;
  font-family: "Poppins";
  color: #000000;
  text-align: left;
  font-weight: 200;
  display: flex;
  background-color: white;
  width: fit-content;
  display: block;
  position: absolute;
  border: $color-primario solid 1pt;
  box-shadow: 2px 2px;
  list-style-type: none;
  width: 20%;
}
.vr {
  border-left: 6px solid $color-primario;
  height: 95%;
}
.informacion-tarjeta {
  width: 100%;
  flex-direction: row;
}
.informacion-tarjeta-margen {
  width: 100%;
  flex-direction: row;
  margin: 10px 0px 0px 10px;
}
.informacion-tarjeta-font {
  font-size: 0.85em;
}

.negritas {
 font-weight: bold;
 font-size: 14px;
}
.icono-tarjeta {
 font-weight: 600;
}
.prospecto-estado {
  display: flex;
  flex-direction: row;
  margin: 10px 0px 0px 0px;
}
.prospecto-estado__icono {
  padding-left: 20px;
}
.prospecto-estado__fase_texto {
  display: contents;
}
.prospecto-estado__fase_texto label {
  margin-left: 10px;
}
.prospecto_datos {
  display: flex;
  flex-direction: row;
  margin: 10px 0px 0px 0px;
}
$color-primario: #b8725a;
$color-textos: #696158;
$poppins: "Poppins";
$negro: #1e2120;

.tarjeta-prospecto {
  cursor: pointer;
  margin-top: 5px;
  border-left: 7px solid $color-primario;
  border-radius: 0px;
}
.tarjeta-prospecto:hover {
  transform: scale(1.02);
  transition: all 0.2s ease-in-out;
}
.tarjeta-prospecto:active {
  background-color: #f6efed !important;
}
.contenedor-nombre {
  text-align: initial;
}
.contenedor-nombre small {
  padding-left: 20px;
}
.contenedor-icono-p {
  text-align: end;
}
.contenedor-icono-p i {
  padding-right: 20px;
  font-size: 22px;
  padding-top: 10px;
}

.nombre-prospecto {
  cursor: pointer;
  font-family: $poppins;
  text-align: left;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 0.05em;
  color: $negro;
}
.row-datos {
  margin-top: 10px;
  margin-bottom: 10px;
}
#icono-etapa {
  color: $color-primario;
  font-size: 25px;
}
.nombre-etapa {
  width: 80%;
  color: $color-primario;
  font-family: $poppins;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.05em;
}

@media all and (max-width: 767px) {
  .prospecto_datos {
    flex-direction: column;
  }
  .contenedor-icono-p i {
    padding-right: 20px;
    font-size: 20px;
  }
  .row-datos {
    margin-top: 10px;
  }
  .row-datos .row-cols-12 {
    max-width: 150% !important;
    margin-top: 10px;
  }
  .nombre-etapa {
    font-size: 14px;
  }
  #icono-etapa {
    font-size: 20px;
  }
  .nombre-prospecto {
    font-size: 13px;
  }
  .prospecto-monto {
    margin-top: 5px;
  }  
}
</style>
